import React from 'react';
import {connect} from 'react-redux';
import {actions, Errors, Form} from 'react-redux-form';
import {Link} from 'react-router-dom';
import {Col, Grid, Row, OverlayTrigger, Tooltip, Button} from 'react-bootstrap';
import { TradeSiteOnly, tradeSiteDisabled} from '../../utils/toggles';

import ErrorMessages from '../login/error-messages';
import PageTitle from '../common/page-title';
import ArrowButton from '../common/button-arrow';
import RequiredInput from '../common/form/elements/required-input';
import InlineCKEditor from '../common/editor/inline-editor';
import { isLoggedIn, check as anyUserTypeLoggedIn } from '../../utils/tokenUtils';
import {validateRegistrationOutlet} from '../../actions/outlet';
import {loadPageContent} from '../../actions/content';
import TextViewer from '../common/editor/text-viewer';
import IgniteUkLogo from '../../assets/img/ignite_logo_black.png';

import './styles.css';
import t from '../../data/translations';

const RegisterLink = ({ onRegistrationPage }) => (
  <div
    className="trade-registration"
  >
    <Link
      to={{
        pathname: `${onRegistrationPage ? '/registration' : ''}/${anyUserTypeLoggedIn() ? 'your-store' : 'about-you'}`,
        state: { doNotKnowCustomerNumber: true }
      }}
    >
    I do not know my customer number
    </Link>
    <OverlayTrigger
      overlay={(
        <Tooltip className="tooltip" id="tooltip">
            Please note if you do not know your customer number, you will be required to complete your
            registration details and your registration will be sent for verification by Imperial Tobacco.
        </Tooltip>
      )}
      placement="right"
    >
      <Button className="tip" tabIndex="-1">
      ?
      </Button>
    </OverlayTrigger>
  </div>
);

class OutletValidationForm extends React.Component {
  handleSubmit = (payload) => {
    const { dispatch, registration, location: { pathname }} = this.props;
    const fromRegistrationPage = /^\/registration\//.test(pathname);

    dispatch(actions.submit(
      'deep.registration.outlet_validation',
      validateRegistrationOutlet(payload, registration, fromRegistrationPage)
    ));
  };
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  constructor(props) {
    super(props);

    this.pageSlug = 'outlet-validation';
    this.state = {};
    if (isLoggedIn()) {
      this.props.dispatch({type: 'START_REGISTRATION_INTERNAL'});
    } else if (!this.props.registration.pending) {
      this.props.dispatch({type: 'START_REGISTRATION_EXTERNAL'});
    }
  }

  componentWillMount() {
    if (this.props.registration.pending && this.props.registration.internal) {
      this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.registration.outlet_validation'));
  }

  render() {
    return (
      this.props.features && !this.props.features.disable_outlet_registration ? (
        <Grid className="outlet-registration user-inner-container" fluid={this.props.registration.internal}>
          <Row>
            <Col lg={12}>
              {this.props.area !== 'retailer' && (
                <img src={IgniteUkLogo} alt="Ignite UK" />
              )}
              <div className={this.props.area === 'retailer' ? 'outlet-registration-title' : ''}>
                <PageTitle>
                  Register
                </PageTitle>
              </div>
            </Col>
          </Row>
          {
            this.props.registration.pending && this.props.registration.internal && (
            <Row>
              <Col lg={12}>
                <InlineCKEditor
                  contents={this.props.contents[`${this.pageSlug}_content_text`]}
                  identifier={`${this.pageSlug}_content_text`}
                  onContentSaved={this.handleContentSaved}
                />
              </Col>
            </Row>
            )}
          {!(this.props.registration.pending && this.props.registration.internal) && <TextViewer pageSlug={this.pageSlug}></TextViewer>}
          <Row className="outlet-validation">
            <Col lg={12}>
              <Form
                model="deep.registration.outlet_validation"
                onSubmit={this.handleSubmit}
                className="outlet-registration-form"
              >
                <Errors className="errors" component={ErrorMessages} model="deep.registration.outlet_validation"/>

                <RequiredInput
                  controlId="customer_number"
                  label={t('outlet.validation.customerNumber')}
                  model=".customer_number"
                  tooltip={tradeSiteDisabled() ? t('outlet.validation.customerNumber.tooltip') : null}
                />

                <RequiredInput
                  controlId="eircode_or_passcode"
                  label={t('outlet.validation.eircode')}
                  model=".eircode_or_passcode"
                  tooltip={tradeSiteDisabled() ? t('outlet.validation.eircode.tooltip') : null}
                />
                <TradeSiteOnly>
                  <RegisterLink onRegistrationPage={this.props.location.pathname.startsWith('/registration/')} />
                </TradeSiteOnly>
                <ArrowButton
                  arrow={false}
                  className="pull-right outlet-registration-form-btn"
                  color="red"
                >
                    Next
                </ArrowButton>
              </Form>
            </Col>
          </Row>
        </Grid>
      ) : <h1 className='outlet-registration-disabled'>{t('registration.disabled')}</h1>);
  }
}


const mapStateToProps = state => ({
  registration: state.registration,
  contents: state.content.list,
  features: state.features
});

export default connect(mapStateToProps)(OutletValidationForm);



// WEBPACK FOOTER //
// ./src/components/outlet-validation/outlet-validation-form.jsx